<template>
  <div class="product-card">
    <div class="product-card__wrapper">
      <div class="product-card__slider product-card-slider">
        <div class="product-card-slider__swiper swiper">
          <div class="product-card-slider__wrapper swiper-wrapper">
            <div class="product-card-slider__slide swiper-slide">
              <Card
                :imgUrl="product.imgPath"
                :imgDesk="product.name"
                :showVideo="props.showVideo"
                :slider="slider"
                @playVideo="$emit('playVideo')"
              ></Card>
            </div>
          </div>
        </div>
      </div>
      <div class="product-card__content">
        <div class="product-card__buttons">
          <CopyLink />
          <Share :title="product.name" :text="product.description" />
        </div>
        <h3 class="product-card__title title">
          {{ product.name }}&nbsp;<sup v-if="product.type === ProductType.CONCEPT">concept</sup>
        </h3>
        <div class="product-card__articule" v-if="product.type !== ProductType.SERVICE">
          Артикул: <span>{{ product.id }}</span>
        </div>
        <div class="product-card__info-wrapper desktop">
          <!--<div class="product-card__subtitle subtitle">
                        Доставим в любую точку России
                    </div>-->
          <div
            class="product-card__info info"
            v-html="product.description"
          ></div>
        </div>
        <div
          v-if="product.notSelectableParams.length > 0"
          class="product-card__characteristic"
        >
          <ul class="product-card__list">
            <li
              v-for="param in product.notSelectableParams.slice(0, 3)"
              :key="param.id"
              class="product-card__item"
            >
              <span>{{ param.name }}:</span>
              <span class="dots"
                >..................................................................................</span
              >
              <span>{{ param.toString() }}</span>
            </li>
          </ul>
          <SpoilerMini
            v-if="product.notSelectableParams.length > 3"
            title="Посмотреть все характеристики"
          >
            <template #content>
              <ul class="product-card__list">
                <li
                  v-for="param in product.notSelectableParams.slice(
                    3,
                    product.notSelectableParams.length,
                  )"
                  :key="param.id"
                  class="product-card__item"
                >
                  <span>{{ param.name }}:</span>
                  <span class="dots"
                    >..................................................................</span
                  >
                  <span>{{ param.toString() }}</span>
                </li>
              </ul>
            </template>
          </SpoilerMini>
        </div>
        <div
          class="product-card__size"
          v-for="param in product.selectableParams"
        >
          <div class="product-card__size-title">{{ param.name }}:</div>
          <div class="product-card__size-radio">
            <Radio
              @change="selectedParams[param.id].value = value.value"
              v-for="(value, i) in param.values"
              :key="String(param.id) + String(i)"
              :label="value.value"
              name="size"
              :checked="selectedParams[param.id].value === value.value"
            ></Radio>
          </div>
        </div>

        <div v-if="showSizeSelector" class="product-card__size">
          <div class="product-card__size-title">{{ sizeAttributeName }}:</div>
          <div class="product-card__size-radio">
            <button
              v-for="item in sizedItems"
              :key="item.id"
              type="button"
              class="size-btn"
              :class="{
                'size-btn--active': selectedItemId === item.id,
                'size-btn--disabled': item.stock <= 0,
              }"
              :disabled="item.stock <= 0"
              @click.prevent="selectSize(item)"
            >{{ item.attributeValue.value }}</button>
          </div>
          <div v-if="!selectedItemId" class="product-card__size-hint">Выберите размер</div>
        </div>
        <!--<div class="product-card__terms">
          <div class="product-card__terms-item">
            <span class="terms-title">Возврат и обмен</span>
            <ToolTips
              content="Если не подойдет размер, вы можете вернуть в течение 7 дней после покупки в интернет-магазине (фактического получения) и 14 дней после покупки в шоуруме. Подоробности у сотрудника."
            />
          </div>
          <div class="product-card__terms-item">
            <span class="terms-title"
              >Доставка по РФ
              <span v-if="product.price >= 25000">бесплатно</span></span
            >
            <ToolTips
              content="Мы доставим ваш заказ ТК СДЭК. При покупке от 25 т.р. доставка бесплатная. Подробности у сотрудника"
            />
          </div>
        </div>-->
        <!-- <div class="product-card__video">
                            <Play/>
                            <div class="text">Посмотрите видео</div>
                        </div> -->
        <div class="product-card__request">
          <div class="product-card__cost-info">
              <template v-if="product.type === 0">
                <span class="status" v-if="displayInStock">В наличии</span>
                <span class="status" v-else>Нет в наличии</span>
              </template>
            <span class="cost title" v-if="displayPrice > 0">
              <span class="cost--old" v-if="displayOldPrice > 0">{{
                displayOldPrice
              }}</span>
              {{ displayPrice }}&nbsp;₽
            </span>
          </div>
          <Button
            :title="cartBtnTitle"
            :disabled="!canAddToCart"
            v-if="displayInStock || product.type !== 0"
            @click.prevent="addToCart"
          />
        </div>
      </div>
    </div>
    <div class="product-card__info-wrapper mobile">
      <div class="product-card__subtitle subtitle">Доставим по всей РФ</div>
      <div class="product-card__info info" v-html="product.description"></div>
    </div>
  </div>

  <teleport to="body">
    <Form
      @close="isOpenForm = false"
      v-if="isOpenForm"
      :product-id="product.id"
      :product-type="product.type"
    />
  </teleport>
</template>

<script setup lang="ts">
import Card from "~/components/UI/Card/Card.vue";
import Share from "~/components/UI/btn/Share.vue";
import CopyLink from "~/components/UI/btn/CopyLink.vue";
import Play from "~/components/UI/btn/Play.vue";
import Button from "~/components/UI/btn/Button.vue";
import StepBtn from "~/components/UI/btn/stepSlideBtn.vue";

import SpoilerMini from "~/components/UI/Containers/Spoiler-Mini.vue";
import ToolTips from "~/components/UI/Containers/ToolTips.vue";
import Radio from "~/components/UI/Form/RadioBtn.vue";
import { Product } from "~/dto/Product.js";
import { CartHelper } from "~/helpers/CartHelper";
import { CartService } from "~/services/CartService";
import { Cart } from "~/dto/Cart.js";
import type { PropType } from "vue";
import { ProductType } from "~/enums/ProductType";
import Form from "~/components/Modals/Form.vue";
import { ProductItem } from "~/api/ProductItem";
import type { ProductItemInterface } from "~/api/ProductItem";

const props = defineProps({
  product: {
    type: Product as PropType<Product>,
    required: true,
  },
  showVideo: {
    type: Boolean,
    default: false,
  },
});
const slider = props.product!.images.map((f) => {
  return {
    id: f.id,
    src: f.path,
  };
});

// Если на страницу товара пришли с вайба (?vibe=<id>, ТЗ-006) — атрибутируем
// позицию корзины этому вайбу (ТЗ-017).
const route = useRoute();
const vibeId = computed(() => {
  const v = route.query.vibe;
  return typeof v === "string" && v ? Number(v) : null;
});

const isOpenForm = ref(false);
const cart = ref<Cart | null>(null);

const selectedParams = {};
props.product.selectableParams.forEach((param) => {
  selectedParams[param.id] = ref(param.values[0].value);
});

const selectedVariantId = computed(() => {
  for (let paramId in selectedParams) {
    const value = selectedParams[paramId].value;
    const param = props.product.selectableParams.find(
      (el) => el.id === +paramId,
    );
    if (!param) continue;

    const paramValue = param.values.find((el) => el.value === value);
    if (!paramValue) continue;

    return paramValue.variants[0];
  }

  return null;
});

// ── Размерный селектор (product_items / SKU) — отдельная ось от variantId
// выше (тот — цвет, старая self-join модель Product). Цена/остаток уже
// встроены в ответ /product-items, отдельно /prices и /warehouse-stocks
// дёргать не нужно.
const items = ref<ProductItemInterface[]>([]);
const selectedItemId = ref<number | null>(null);

const sizedItems = computed(() => items.value.filter((i) => i.attributeValue));
const showSizeSelector = computed(() => sizedItems.value.length > 0);
const sizeAttributeName = computed(() => sizedItems.value[0]?.attribute?.name ?? "Размер");
const selectedItem = computed(
  () => items.value.find((i) => i.id === selectedItemId.value) ?? null,
);

// Falls back to product.price/priceOld both when there's no selector at all
// and before a size is picked — otherwise the price box goes blank until
// the user selects something, which reads as broken rather than "pick a size".
const displayPrice = computed(
  () => selectedItem.value?.price?.retailPrice ?? props.product.price,
);
const displayOldPrice = computed(
  () => selectedItem.value?.price?.oldPrice ?? props.product.priceOld,
);
// Before a size is picked this means "is *any* size available" (so the
// button/status don't read as sold-out before the user has even chosen);
// once one is selected it reflects that specific item's stock.
const displayInStock = computed(() => {
  if (!showSizeSelector.value) return props.product.amount > 0;
  if (!selectedItemId.value) return sizedItems.value.some((i) => i.stock > 0);
  return (selectedItem.value?.stock ?? 0) > 0;
});

async function fetchItems() {
  try {
    const data = await ProductItem.getByProduct(props.product.id);
    // Один item без атрибута = товар без размерного учёта — селектор не
    // показываем, цена/наличие остаются product.price/product.amount.
    items.value = data.length === 1 && !data[0].attributeValue ? [] : data;
  } catch {
    items.value = [];
  }
}

function selectSize(item: ProductItemInterface) {
  if (item.stock <= 0) return;
  selectedItemId.value = item.id;
}

const canAddToCart = computed(() => {
  if (props.product.type !== ProductType.PRODUCT) return true;
  if (showSizeSelector.value && !selectedItemId.value) return false;
  return true;
});

function addToCart() {
  if (props.product.type !== ProductType.PRODUCT) {
    isOpenForm.value = true;
    return;
  }
  if (!canAddToCart.value) return;

  let variantId = selectedVariantId.value;
  const itemId = showSizeSelector.value ? selectedItemId.value : null;
  const item = selectedItem.value;
  const attributeLabel = item?.attribute?.name ?? null;
  const attributeValue = item?.attributeValue?.value ?? null;

  const find = cart.value!.findProduct(props.product.id, variantId, itemId, vibeId.value);
  if (find) return;

  CartService.getInstance().addProduct(
    props.product.id,
    props.product.name,
    displayPrice.value,
    variantId,
    1,
    itemId,
    attributeLabel,
    attributeValue,
    vibeId.value,
  );
}

const cartBtnTitle = computed(() => {
  if (showSizeSelector.value && !selectedItemId.value) return "Выберите размер";

  const variantId = selectedVariantId.value;
  const itemId = showSizeSelector.value ? selectedItemId.value : null;
  const find = cart.value?.findProduct(props.product.id, variantId, itemId, vibeId.value);
  return find && props.product.type === ProductType.PRODUCT
    ? "В корзине"
    : props.product!.buttonTitle;
});

onMounted(() => {
  if (process.client) cart.value = CartHelper.getCart().value;
  fetchItems();
});
</script>

<style scoped lang="scss">
.size-btn {
  min-width: 4.4rem;
  height: 4.4rem;
  padding: 0 1.2rem;
  margin: 0 0.8rem 0.8rem 0;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  background: transparent;
  font-size: 1.4rem;
  cursor: pointer;
  transition: border-color 0.2s, opacity 0.2s;

  &--active {
    border-color: #000;
    border-width: 2px;
  }

  &--disabled,
  &:disabled {
    color: rgba(0, 0, 0, 0.3);
    border-color: rgba(0, 0, 0, 0.08);
    text-decoration: line-through;
    cursor: not-allowed;
  }
}

.product-card__size-hint {
  font-size: 1.3rem;
  color: #b00;
  margin-top: 0.4rem;
}

.product-card__request .btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
